import { SaveSearchFrequencyEnum } from 'common/data/save-search/frequency.enum';
import { i18nTranslate } from 'common/helper/i18n/translate';

export const saveSearchFrequencies: Array<{ label: string; value: SaveSearchFrequencyEnum }> = [
  {
    label: i18nTranslate('Hourly'),
    value: SaveSearchFrequencyEnum.HOURLY,
  },
  {
    label: i18nTranslate('Daily'),
    value: SaveSearchFrequencyEnum.DAILY,
  },
  {
    label: i18nTranslate('Three_days'),
    value: SaveSearchFrequencyEnum.THREE_DAYS,
  },
  {
    label: i18nTranslate('Weekly'),
    value: SaveSearchFrequencyEnum.WEEKLY,
  },
  {
    label: i18nTranslate('Off'),
    value: SaveSearchFrequencyEnum.OFF,
  },
];
